import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = ['parcelOption', 'productOption']

  declare readonly parcelOptionTargets: HTMLInputElement[]
  declare readonly productOptionTargets: HTMLInputElement[]

  connect(): void {
    this.updateGroupLabel()
  }

  updateGroupLabel(): void {
    const groupOption = this.parcelOptionTargets.find(option => option.value === 'group')
    if (groupOption === undefined) return

    const optionText = groupOption.nextElementSibling
    if (!(optionText instanceof HTMLElement)) return

    const productConsolidation = this.productOptionTargets.find(option => option.checked)?.value
    const label =
      productConsolidation === undefined || productConsolidation === 'none'
        ? 'Group'
        : 'Group before Product Consolidation'

    optionText.textContent = label

    if (!groupOption.checked) return

    const triggerText = groupOption
      .closest('ui-input-select')
      ?.querySelector('[data-ui-select-target="trigger"]')?.firstElementChild
    if (triggerText instanceof HTMLElement) triggerText.textContent = label
  }
}
